import * as React from "react"
import {Grid, Skeleton} from "@mui/material";


export default function PriceEvolutionChartLoadingBlock() {
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <Skeleton variant="rectangular" height={300}/>
        </Grid>
    </Grid>
}